export default __webpack_public_path__ + "static/media/video-stop.b06aad27.svg";